const HEIGHT_TRANSITION_DURATION_MS = 375;
const CONTENT_TRANSITION_DURATION_MS = 225;
const FADE_TRANSITION_DURATION_MS = 150;
const harmonicaIframeHeaderPaddingProp = "--iframe--header--padding-left";
const wrapperCls = "_uihwxhgb99";
const headingWrapperCls = "_uihh1dwz6nr";
const headingCls = "_uihh1hs9cbn";
const headingContentCls = "_uihh14ssp4t";
const headerButtonCls = "_uihhd53am1";
const badgeWrapperCls = "_uihbih2s4z";
const badgeImageCls = "_uihb8w67mz";
const indexBadgeCls = "_uihidw8ktd";
const headerWrapperCls = "_uihhx2kcu8";
const headerTextCls = "_uihhj8pbrf";
const expandCls = "_uiheupmoa9";
const iconWrapperCls = "_uihio0ndc";
const chevronCls = "_uihc1wt0he0";
const crossCls = "_uihc21x5kl";
const contentContainerCls = "_uihc8i80wz";

// Static description wrapper which is displayed while the component is
// collapsed
const descriptionWrapperCls = "_uihd1b44uoh";
const descriptionPanelWrapperCls = "_uihdf13l5p";
const descriptionCls = "_uihd1vipr0r";
const descriptionPanelCls = "_uihdkgy0od";
const descriptionToggleCls = "_uihd1s4utcb";
const iframeCls = "_uihiy4l5qm";
const textCls = "_uiht1pcoh6h";
const retryButtonCls = "_uihr1gdhq3w";
const throbberCls = "_uiht17yxv6u";
const fadeCls = "_uihfcanxux";
const captionCls = "_uihc1hstptq";
const scrambledCls = "_uihs1dfgjv2";

export { CONTENT_TRANSITION_DURATION_MS, FADE_TRANSITION_DURATION_MS, HEIGHT_TRANSITION_DURATION_MS, badgeImageCls, badgeWrapperCls, captionCls, chevronCls, contentContainerCls, crossCls, descriptionCls, descriptionPanelCls, descriptionPanelWrapperCls, descriptionToggleCls, descriptionWrapperCls, expandCls, fadeCls, harmonicaIframeHeaderPaddingProp, headerButtonCls, headerTextCls, headerWrapperCls, headingCls, headingContentCls, headingWrapperCls, iconWrapperCls, iframeCls, indexBadgeCls, retryButtonCls, scrambledCls, textCls, throbberCls, wrapperCls };
import "./comp.harmonica-iframe.style.linaria.module.css";
//# sourceMappingURL=comp.harmonica-iframe.style.js.map
